export default "__VITE_ASSET__B9RENJCu__"